import React, { useState } from "react";

const DoubtBar = ({ placeholder, onSearch }) => {
    const [query, setQuery] = useState("");
    return (
    <div style={styles.searchContainer}>
        <input
        type="text"
        placeholder={placeholder || "Add doubt here..."}
        style={styles.input}
        onChange={(e) => setQuery(e.target.value)}
        />
        <button style={styles.button} onClick={()=>onSearch(query)}>
        ASK
        </button>
    </div>
    );
};

const styles = {
  searchContainer: {
    display: "flex",
    alignItems: "center",
    border: "1px solid #ccc",
    borderRadius: "20px",
    padding: "5px 10px",
    width: "600px",
    margin: "10px auto",
    backgroundColor: "#fff",
  },
  input: {
    flex: 1,
    border: "none",
    outline: "none",
    padding: "5px",
    fontSize: "16px",
  },
  button: {
    border: "none",
    background: "transparent",
    cursor: "pointer",
    fontSize: "18px",
  },
};

export default DoubtBar;